import React from 'react';

export { useIsWidthUp } from './use_width_up';

export { disableMuiButton, enableMuiButton } from './buttons';

export { WindowNamespace } from './windowns';

export { debounce } from './debounce';

export { formatPrice } from './price';

export { validateEmail } from './email';

export { genGetLabel, genOptions, genHtmlOptions, genMenuItems, objectListToMenuItems, genGridOptions } from './menuitems';

export { compareObjectKeys } from './objects';

export { copyTextToClipboard } from './clipboard';

export { fromServerErrors, muiErrorAttrs, validate, clearError, isOk, serverErrorMessage, ensureOk } from './errors';

export { humanFileSize } from './size';

export { asJSONPath, fromJSONPath } from './jspath';

export { url2filename, downloadAsFile } from './file';

export { readableDate } from './date';

export { checkAndAddHttpPrefix } from './http_prefix';

export { ScheduleEvaluator } from './schev';

export { toTitleCase } from './to_title_case.js';

export { LANGUAGES, DEFAULT_LANG, LANGUAGE_MAP } from './lang';
export { defaultLang } from './defaultLang';

export const GMapContext = React.createContext();

export const EMDASH = String.fromCharCode(8212);

export { makeCloudWatchInsightsUrl, generateCWLink } from './logsinsights';
